<template>
  <component :is="componentToShow" />
</template>

<script>
import { authUser } from '@/utils/auth';
import adminAttendances from '@/views/pages/hrms/attendances.vue';
import myAttendance from '@/views/pages/hrms/my-attendance.vue';

export default {
  data() {
    return { componentToShow: null };
  },
  created() {
    const user = authUser();
    if (user?.type === 'ADMIN' || user?.role?.is_hr === true) {
      this.componentToShow = adminAttendances; 
    } else {
      this.componentToShow = myAttendance;   
    }
  },
};
</script>